import React from 'react';
import { Link } from 'react-router';
import Icon, { Icons } from '../../../../Icons/Icon';
import {
  container,
  imageContainer,
  textContainer,
  eventImage,
  title as titleStyle,
  subtext as subtextStyle,
} from './styles.module.css';

const ResultItem = ({
  disableLinkOut,
  image,
  title,
  subtext,
  permalink,
  onClick = () => {},
}) => {
  const Component = disableLinkOut ? 'div' : Link;
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Component
      className={container}
      to={disableLinkOut ? undefined : permalink}
      onClick={onClick}
    >
      <div className={imageContainer}>{image}</div>
      <div className={textContainer}>
        <span className={titleStyle}>{title}</span>
        {subtext && <span className={subtextStyle}>{subtext}</span>}
      </div>
    </Component>
  );
};

export const EventImage = ({ src, title }) => (
  <img src={src} alt={title} className={eventImage} />
);
export const CategoryImage = () => <Icon icon={Icons.TROPHY.GREY} />;
export const LocationImage = () => <Icon icon={Icons.LOCATION_PIN.GREY} />;

export default ResultItem;
